import { Link } from 'react-router-dom';

const founders = [
  {
    num: '[ A · 01 ]',
    vlabel: 'DALQUIST · D.',
    first: 'Dean',
    last: 'Dalquist',
    role: 'Co-founder & Chief Executive Officer',
    yrs: '32 years',
    tenureText: 'of Class 1 railway engineering leadership.',
    bio:
      'Visionary. Accomplished leadership experience in safety, engineering maintenance, financial management, communications, and project management.',
    credits: [
      { k: 'Discipline', v: 'Engineering Leadership' },
      { k: 'Focus', v: 'Safety · Maintenance · Project Management' },
      { k: 'Role', v: 'Co-founder & CEO' }
    ]
  },
  {
    num: '[ A · 02 ]',
    vlabel: 'CURILLA · D.',
    first: 'Darrell',
    last: 'Curilla',
    role: 'Co-founder & Chief Mechanical Officer',
    yrs: '42 years',
    tenureText: 'of railway mechanical maintenance and innovation.',
    bio:
      'Transformational leader, systems thinker. Lead process and mechanical designer. Managing Director of Rail Shop Services Inc., bringing deep operational knowledge of locomotive and rail-car maintenance to every program.',
    credits: [
      { k: 'Discipline', v: 'Mechanical Maintenance' },
      { k: 'Focus', v: 'Process & Mechanical Design' },
      { k: 'Also', v: 'Managing Director, Rail Shop Services Inc.' },
      { k: 'Role', v: 'Co-founder & CMO' }
    ]
  },
  {
    num: '[ A · 03 ]',
    vlabel: 'GRAETZ · T.',
    first: 'Todd',
    last: 'Graetz',
    role: 'Co-founder & Chief Information Officer',
    yrs: '16 years',
    tenureText: 'of railway information technology.',
    bio:
      'Trailblazer. Co-Founder of the BNSF Railway UAS Program and Co-founder of Aerolane. Brings hands-on expertise in standing up unmanned aircraft operations inside Class 1 IT environments.',
    credits: [
      { k: 'Discipline', v: 'Railway Information Technology' },
      { k: 'Programs', v: 'Co-Founder · BNSF Railway UAS Program' },
      { k: 'Also', v: 'Co-founder · Aerolane' },
      { k: 'Role', v: 'Co-founder & CIO' }
    ]
  }
];

export default function Leadership() {
  return (
    <>
      <section className="page-hero">
        <div className="page-hero-bg" aria-hidden="true" />
        <div className="wrap">
          <div className="crumbs">
            <Link to="/">Home</Link>
            <span className="sep">/</span>
            <span className="here">Leadership</span>
          </div>

          <div className="page-hero-grid">
            <div>
              <div className="eyebrow reveal" style={{ marginBottom: 28 }}>
                RFS · Founding Team
              </div>
              <h1 className="display h1 reveal d1" style={{ margin: '0 0 28px' }}>
                The people <br />behind the <em>mission.</em>
              </h1>
              <p className="lede reveal d2">
                Eighty combined years of Class&nbsp;1 railway engineering, mechanical maintenance, and information technology — applied to a single mission: smarter, safer rail through aerial intelligence.
              </p>
            </div>

            <aside className="page-meta reveal d2" aria-label="At a glance">
              <div className="page-meta-row"><span className="k">Founders</span><span className="v">03</span></div>
              <div className="page-meta-row"><span className="k">Combined Years</span><span className="v">80+ in Rail</span></div>
              <div className="page-meta-row"><span className="k">Disciplines</span><span className="v">Engineering · Mechanical · IT</span></div>
              <div className="page-meta-row"><span className="k">Based</span><span className="v">Fort Worth, Texas</span></div>
            </aside>
          </div>
        </div>
      </section>

      <section className="team">
        <div className="wrap">
          <div className="team-header reveal">
            <div className="num">[ 01 ] &nbsp; Founders</div>
            <h2 className="title">Co-founders &amp; <em>operating</em> team.</h2>
          </div>

          {founders.map((f) => (
            <article className="leader reveal" key={f.last}>
              <div className="leader-num">{f.num}</div>
              {/* Portrait placeholder removed until headshots are available.
                  Re-enable by restoring this block (and the 3-column
                  .leader grid in App.css) once photos are ready:
              <div className="leader-portrait">
                <div className="corners"><i></i><b></b></div>
                <div className="leader-portrait-placeholder" aria-hidden="true">
                  Drop portrait of {f.first} {f.last}
                </div>
                <div className="vlabel">{f.vlabel}</div>
              </div>
              */}
              <div className="leader-meta">
                <h3 className="leader-name">{f.first} <em>{f.last}</em></h3>
                <div className="leader-role">{f.role}</div>
                <p className="leader-tenure">
                  <span className="yrs">{f.yrs}</span> {f.tenureText}
                </p>
                <p className="leader-bio">{f.bio}</p>
                <ul className="leader-credits">
                  {f.credits.map((c) => (
                    <li key={c.k}>
                      <span className="k">{c.k}</span>
                      <span className="v">{c.v}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="cta-band">
        <div className="cta-band-bg" aria-hidden="true" />
        <div className="wrap">
          <div className="cta-band-grid">
            <h2 className="cta-title reveal">
              Want to put this team <br />on your <em>next mission?</em>
            </h2>
            <Link to="/#contact" className="cta-link reveal d1">
              <span>Contact Railway Flight Solutions</span>
              <span className="arrow">→</span>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
